import { render } from "./PdfDashboard.vue?vue&type=template&id=40ed1a9a&scoped=true"
import script from "./PdfDashboard.vue?vue&type=script&lang=js"
export * from "./PdfDashboard.vue?vue&type=script&lang=js"

import "./PdfDashboard.vue?vue&type=style&index=0&id=40ed1a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ed1a9a"]])

export default __exports__